import { useEffect, useState } from "react";
import { api } from "../api/client";

/** Shelf role from GET /api/me. Null while loading. Failures stay viewer. */
export function useShelfRole(): string | null {
  const [role, setRole] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    Promise.resolve()
      .then(() => api.me())
      .then((me) => {
        if (!cancelled) setRole(me.role);
      })
      .catch(() => {
        if (!cancelled) setRole("viewer");
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return role;
}
